module.exports = __webpack_public_path__ + "img/kv1_pc.bb887a4c.jpg";